import script from "./OrgInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgInfo.vue?vue&type=script&setup=true&lang=js"

import "./OrgInfo.vue?vue&type=style&index=0&id=2e99488a&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e99488a"]])

export default __exports__